<template>
  <Toast />
  <ConfirmDialog></ConfirmDialog>
  <div class="layout">
    <div class="layout__sidebar">
      <SidebarComponent v-if="isLoggedIn" />
    </div>
    <div class="layout__main">
      <div class="layout__header">
        <HeaderComponent />
      </div>
      <div class="layout__view">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useStore } from 'vuex'
import HeaderComponent from './components/HeaderComponent'
import SidebarComponent from './components/SidebarComponent'

export default defineComponent({
  components: {
    HeaderComponent,
    SidebarComponent
  },
  setup() {
    const store = useStore()
    const isLoggedIn = computed(() => {
      return store.state.status.loggedIn
    })

    return { isLoggedIn }
  },
})
</script>
